export const DeviceSize = {
  mobile: 992,
  tablet: 992,
  laptop: 1324,
  desktop: 2024,
};
